import { faRectangleList } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core/styles";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import {
  Accordion,
  AccordionSummary,
  Alert,
  Card,
  TextField,
  Typography,
} from "@mui/material";
import AccordionDetails from "@mui/material/AccordionDetails";
import Checkbox from "@mui/material/Checkbox";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Icon } from "@progress/kendo-react-common";
import axios from "axios";
import { useFormik } from "formik";
import moment from "moment";
import { useAuth } from "oidc-react";
import React, { Fragment, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Container, Row } from "reactstrap";
import * as Yup from "yup";
import { RetireeHealthCompanyArray as companyArray, getUserRole, isOlderThen, ShowError, Sh, companyArrayowSucess, ShowSucess } from "../../_helper/helper";
import { loadingPanel } from "../../CommonComponents/CommonFunction";
import ActiveHealthAndDeductionPlan from "./Components/ActiveHealthAndDeductionPlan";

import ConfirmationModel from "./Components/ConfirmationModel";
import DependentSelection from "./Components/DependentSelection";
import DocumentViewer from "./Components/DocumentView";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    ".&.MuiExpansionPanelSummary-content": {
      padding: 0,
    },
    ".css-sh22l5-MuiButtonBase-root-MuiAccordionSummary-root.Mui-expanded": {
      minHeight: "32px",
    },
    "& .MuiPaper-root": {
      background: "none",
      display: "block",
    },
    margin: "0 !important",
    borderTopWidth: 1,
    borderTopColor: "#ccc",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: "70%",
    flexShrink: 0,
    display: "flex",
    alignItems: "center",
    fontWeight: "bold",
  },
}));

const HealthOpenEnrollmentMain = () => {
  const classes = useStyles();
  const { id: employeeId } = useParams()

  const initialDependent = {
    lastName: "",
    firstName: "",
    relation: "",
    ssn: "",
    gender: "",
    dob: "",
    mailingAddress: "",
    email: "",
    middleName: "",
  };

  const [dependentInformation, setDependentInformation] = useState([]);
  const [deletedDependent, setdeletedDependent] = useState([]);
  const [isDocumentViewer, setIsDocumentViewer] = useState(false);

  const [isConfirmationModel, setIsConfirmationModel] = useState(false);
  const [ConfirmationData, setConfirmationData] = useState({});

  const [expanded, setExpanded] = React.useState({
    empDetail: true,
    healthandDeduction: true,
    dependent: true,
  });

  const handleChangeExpanded = (panel) => (event, isExpanded) => {
    setExpanded((prevState) => ({
      ...prevState,
      [panel]: isExpanded,
    }));
  };
  const { userData } = useAuth();


  const [show, setShow] = useState(false);
  const [loding, setLoading] = useState(false);
  const [defaultOpen, setDefaultOpen] = useState(true);
  const [selfData, setSelfData] = useState({});

  const [schema, setPerformanceSchema] = useState({
    employee_no: Yup.string().required("Employee No. is required"),
    DOB: Yup.string().required("DOB is required"),
    last_name: Yup.string().required("Last Name is required"),
    ssn: Yup.string()
      .required("SSN is required")
      .test(
        "len",
        "Must be exactly 4 characters",
        (val) => val && val.toString().length === 4
      ),
  });

  const initialItem = {
    employee_no: "",
    DOB: "",
    last_name: "",
    ssn: "",
    role: '',
    HealthVendor: "",
    healthPlan: "",
    UID: "",
    Employeetype: "",
    healthDeductionClass: "",
    subscriberId: "",
    id: "",
    amount: "",
    email: "",
    mailingAddress: "",
    oldHelthPlan: "",
    oldHelthVendor: ""
  };


  useEffect(() => {
    if (employeeId) {

      setLoading(true)
      getBenefitsData(employeeId)
      // searchEmployeeAPI(userData?.profile?.DOB, userData?.profile?.SSN, userData?.profile?.LastName, userData?.profile?.EmployeeID)
      // setValues({
      //   ...values,
      //   DOB: userData?.profile?.DOB,
      //   employee_no: userData?.profile?.EmployeeID,
      //   last_name: userData?.profile?.LastName,
      //   ssn: userData?.profile?.SSN,
      // })
    }
  }, [employeeId])

  const handleUpdatePlan = () => {
    if (values?.UID && values?.healthPlan && values?.HealthVendor) {
      setLoading(true);
      const payload = {
        uid: values?.UID,
        healthVendor: values?.HealthVendor,
        healthPlan: values?.healthPlan,
        healthDeductionClass: values?.healthDeductionClass,
      };
      axios
        .put(
          `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/update`,
          [{ ...payload }],
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem(
                "jwt_access_token"
              )}`,
            },
          }
        )
        .then((response) => {
          setLoading(false);
          ShowSucess("Successfully Updated.");
        })
        .catch((error) => {
          setLoading(false);
          ShowError("Internal Server Error !");
        });
    } else {
      ShowError("Please select any health plan");
    }
  };



  const onSubmit = (e) => {
    // API Calling
    setLoading(true);
    // searchEmployeeAPI(values?.DOB, values?.ssn, values?.last_name, values?.employee_no);
    getBenefitsData(employeeId);
  };

  const handleDependentUpdate = async (newDependentInfo) => {
    if (newDependentInfo && Object.keys(newDependentInfo).length) {
      dependentInformation.push(newDependentInfo)
    }
    if (
      dependentInformation.some(
        (i) =>
          !i.firstName ||
          !i.lastName ||
          !i.middleName ||
          (!i["role"]?.includes('Coverage') && i.HealthSubscriberID && !i.relation) ||
          !i.gender ||
          (i?.relation === 'Child' && isOlderThen(i.dob))
        // ||
        // !i.dob
      )
    ) {
      ShowError("Please Check Dependent Information");
      return false;
    }
    setLoading(true);
    let currnetClassValue = ""
    if (values?.healthPlan && values?.HealthVendor) {
      currnetClassValue = await setClassValues(dependentInformation)
    }

    axios
      .post(
        `${process.env.REACT_APP_API_DOTNET_URL}/BenefitsMASTER/CreateOrUpdateDeteteBenefits`,
        {
          createnupdate: [
            ...dependentInformation?.map((i) => {
              i?.uid && delete i.ssn
              return {
                ...i, dependentFor: "Health", healthDeductionClass: i.HealthSubscriberID ? currnetClassValue : "",
                healthSubscriberID: values?.healthPlan && values?.HealthVendor ? i.HealthSubscriberID : "",
                employeeId: !i?.uuid ? ' ' : i.employeeId, healthType: i.relation
              }
            }),
            ...[
              {
                uid: values?.UID,
                healthVendor: values?.HealthVendor,
                healthPlan: values?.healthPlan,
                healthDeductionClass: currnetClassValue,
                subscriberId: values?.subscriberId,
                id: values?.id,
                dependentFor: "Health",
                approvedBy: userData?.profile?.EmployeeID,
                ...(!values?.healthPlan && !values?.HealthVendor && { healthSubscriberID: "" })
              },
            ],
          ],
          deletedList: deletedDependent,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          },
        }
      )
      .then(async (response) => {
        await getBenefitsData(values?.employee_no);
        ShowSucess("Successfully!");
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const handleDependentDelete = (uid) => {
    setdeletedDependent([...deletedDependent, uid]);
  };

  const {
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setFieldValue,
    validateForm,
    setValues,
  } = useFormik({
    initialValues: initialItem,
    validationSchema: Yup.object().shape(schema),
    onSubmit,
  });


  const renderGroupCheckbox = (
    size = "large",
    stateName,
    value,
    other = null
  ) => {
    let defaultChk = (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
    if (other && other.matchkey && other.matchkey1) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue &&
            values[other.matchkey1] == other.matchvalue1
          }
          // disabled={
          //   !dependentInformation.some((item) =>
          //     ["Spouse", "Domesticpartner", "Child"].includes(item.relation)
          //   )
          // }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
              // setFieldValue("amount", other?.amount);
            }
            // if (stateName == 'healthPlan' && other?.changeTarget1 && other?.changeTarget1=='HealthVendor' && other?.changeTarget2=='healthPlan') {
            //   setFieldValue(other?.changeTarget1, other?.changeTargetValue1)
            //   setFieldValue(other?.changeTarget2, other?.changeTargetValue2)
            //   setFieldValue('HSAANDPPO',values.HSAANDPPO)
            // }

            setFieldValue(stateName, value);
          }}
        />
      );
    } else if (other && other.matchkey) {
      defaultChk = (
        <Checkbox
          size={size}
          checked={
            values[stateName] == value &&
            values[other.matchkey] == other.matchvalue
          }
          disabled={other?.disabled ? other?.disabled : false}
          onChange={(e) => {
            if (
              stateName == "healthDeductionClass" &&
              other?.changeTarget1 &&
              other?.changeTarget1 == "HealthVendor" &&
              other?.changeTarget2 == "healthPlan"
            ) {
              setFieldValue(other?.changeTarget1, other?.changeTargetValue1);
              setFieldValue(other?.changeTarget2, other?.changeTargetValue2);
            }
            if (stateName == "healthPlan" && other.matchkey) {
              if (e.target.checked) {
                setFieldValue(
                  "healthDeductionClass",
                  values.healthDeductionClass
                );
                setFieldValue(other?.matchkey, other?.matchvalue)
              } else {
                if (values?.oldHelthPlan && values?.oldHelthVendor) {
                  setIsConfirmationModel(true)
                } else {
                  handleUnClick()
                }


                // setFieldValue(
                //   "healthDeductionClass",
                //   ""
                // );
                // setFieldValue(other?.matchkey, "")
              }
            }
            if (e.target.checked) {
              setFieldValue(stateName, value);
            }
            // else {
            //   setFieldValue(stateName, "");
            // }
          }}
        />
      );
    } else {
      defaultChk = (
        <Checkbox
          size={size}
          checked={values[stateName] == value}
          onChange={(e) => {
            setFieldValue(stateName, value);
          }}
        />
      );
    }


    return defaultChk;
  };

  function renderTextInput(stateName, label, others = {}) {
    let other = {
      disabled: false,
      maxLength: "",
      multiline: false,
      required: false,
      shrink: true,
      ...others,
    };
    let { disabled, maxLength, multiline, required, shrink } = other;
    return (
      <TextField
        fullWidth
        size="small"
        inputProps={{
          style: {
            fontSize: "14px",
            paddingTop: "12px",
            width: "100%",
          },
          readOnly: disabled,
        }}
        margin="dense"
        variant="outlined"
        label={label}
        name={stateName}
        id={stateName}
        multiline={multiline}
        rows={multiline ? 3 : 1}
        value={values[stateName]}
        InputLabelProps={{ shrink: shrink ? shrink : false }}
        shrink={shrink ? shrink : false}
        onChange={(e) => {
          if (!disabled) {
            setShow(false);
            handleChange(e);
          }
        }}
        onBlur={handleBlur}
        error={!disabled && touched[stateName] && errors[stateName]}
        helperText={
          !required && !disabled && touched[stateName] && errors[stateName]
        }
        disabled={disabled}
        required={required}
      />
    );
  }

  function renderDateInput(
    stateName,
    label,
    disabled = false,
    minDate = null
    // maxDate
  ) {
    return (
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DesktopDatePicker
          inputVariant={"outlined"}
          margin="dense"
          format="MM/dd/yyyy"
          label={label}
          minDate={minDate}
          // maxDate={maxDate}
          value={values[stateName]}
          KeyboardButtonProps={{ "aria-label": label }}
          disabled={disabled}
          onChange={(value) => {
            const formatDate = value?.$d;
            const date = formatDate
              ? moment(formatDate).format("YYYY-MM-DD hh:mm:ss")
              : null;
            setShow(false);
            setFieldValue(stateName, date);
          }}
          onBlur={handleBlur}
          renderInput={(params) => (
            <TextField
              fullWidth
              margin="dense"
              size="small"
              InputLabelProps={{ shrink: true }}
              {...params}
              error={!disabled && errors[stateName]}
              helperText={!disabled && errors[stateName]}
            />
          )}
        />
      </LocalizationProvider>
    );
  }


  function renderDropDown(stateName, label, value, disabled) {
    return (
      <div>
        <TextField
          margin="dense"
          className="flex w-full  mt-2"
          variant="outlined"
          select
          SelectProps={{ native: true }}
          style={{ width: "100%" }}
          size="small"
          disabled={disabled}
          inputProps={{
            style: {
              fontSize: "14px",
              color: "black",
              paddingTop: "12px",
            },
          }}
          label={label}
          name={stateName}
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            handleChange(e);
          }}
          error={!disabled && errors[stateName]}
          helperText={!disabled && errors[stateName]}
          value={values[stateName]}
        >
          {/* <option value={""} disabled> */}
          {/* value={values[stateName]}> */}
          <option value={""} disabled>
            Select {label}
          </option>

          {value.length &&
            value.map((option) => (
              <option key={option.value} value={option.value}>
                {option.name}
              </option>
            ))}
        </TextField>
      </div>
    );
  }

  const renderCheckbox = (size = "large", stateName, value) => {
    return (
      <Checkbox
        size={size}
        checked={values[stateName] == value}
        onChange={(e) => {
          setFieldValue(stateName, value);
        }}
      />
    );
  };

  const setAmount = (currentClass) => {
    let getAmount = companyArray
      .find((item) => item.vendor_name == values?.HealthVendor)
      ?.vendor_items.find((item) => item.vendor_code == values?.healthPlan)
      ?.classInfo.find(
        (ite) => ite.value == currentClass
      )?.amount;
    setFieldValue("amount", getAmount);
  }

  const setClassValues = async (dependentArray1) => {

    let dependentArray = dependentArray1?.filter((i) => {
      return !!!i.role?.includes("Coverage") && !!i.HealthSubscriberID
    })

    const uniqueValues = [
      ...new Set(dependentArray.map((obj) => obj.relation)),
    ];


    if (uniqueValues.every((i) => i == "")) {
      if (values?.healthDeductionClass != "I") {
        setAmount("I")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to I `);
        setFieldValue("healthDeductionClass", "I");
      }
      return "I";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Spouse", "Domesticpartner"].includes(i))
        : uniqueValues.every(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        )
    ) {
      if (values?.healthDeductionClass != "II") {
        setAmount("II")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to II `);
        setFieldValue("healthDeductionClass", "II");
      }
      return "II";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.every((i) => ["Child"].includes(i))
        : uniqueValues.every((i) => i == "Child" || i == "")
    ) {
      if (values?.healthDeductionClass != "III") {
        setAmount("III")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to III`);
        setFieldValue("healthDeductionClass", "III");
      }
      return "III";
    }
    if (
      uniqueValues.length == 1
        ? uniqueValues.some((i) => ["Spouse", "Domesticpartner"].includes(i)) &&
        uniqueValues.some((i) => ["Child"].includes(i))
        : uniqueValues.some(
          (i) => ["Spouse", "Domesticpartner"].includes(i) || i == ""
        ) && uniqueValues.some((i) => ["Child"].includes(i))
    ) {
      if (values?.healthDeductionClass != "IV") {
        setAmount("IV")
        ShowSucess(`Class changed ${values?.healthDeductionClass} to IV `);
        setFieldValue("healthDeductionClass", "IV");
      }
      return "IV";
    }
  };



  const getDateDifference = () => {

    const currentYear = moment().year();
    const defaultDate = moment(`09-30`, 'MM-DD').year(currentYear);
    const currentDate = moment().year(currentYear);

    // Adjust the year for selectedDate if it is before constDate
    if (defaultDate.isBefore(currentDate)) {
      defaultDate.add(1, 'year');
    }

    // Calculate the difference in days
    const diffDays = defaultDate.diff(currentDate, 'days');

    return { diffDays, defaultDate, currentDate };
  }


  const getBenefitsData = () => {
    const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
    const payload = {
      tableName: "sp_BenefitsDependent_v2",
      SearchParams: `[{"columnName":"EmpId","operator":"=","value":'${employeeId}',"dataType":"VARCHAR"}]`,
      columns: "*",
      pageNumber: 1,
      pageSize: 10000000,
      orderBy: "",
      sortBy: "Role desc",
      orderByMultiple: "",
      limit: 10000000000,
      sortData: "",
      additionalWhere: "",
    };
    axios
      .post(`${newBaseURL}/BenefitAdvanceSearch/Benefits-global`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("jwt_access_token")}`,
          Role: getUserRole(userData),
        },
      })
      .then((response) => {
        let finalData = response?.data?.results;
        let resData = finalData.find((i) => i.Dependants == 'Self')
        finalData = finalData?.map((i) => {
          return {
            ...i,
            firstName: i.FirstName,
            middleName: i.MiddleName,
            lastName: i.LastName,
            role: i.Role,
            relation: i.Relation,
            gender: i.Gender,
            dob: i.DOB,
            mailingAddress: i.MailingAddress,
            email: i.Email,
            healthDeductionClass: i.HealthDeductionClass
          }
        })
        setSelfData(resData)

        let searchData = {
          UID: resData?.UID,
          // id: resData?.UID,
          employee_no: resData?.EmployeeID,
          subscriberId: resData?.SubscriberID,
          Employeetype: resData?.EmployeeType,
          HealthVendor: resData?.HealthVendor,
          healthPlan: resData?.HealthPlan,
          healthDeductionClass: resData?.HealthDeductionClass,
          email: resData?.Email,
          lastName: resData?.LastName,
          mailingAddress: resData?.MailingAddress,
          oldHelthPlan: resData?.HealthPlan,
          oldHelthVendor: resData?.HealthVendor, //
        };
        setValues((state) => { return { ...state, ...searchData } });

        setDependentInformation(
          finalData.length > 1
            ? finalData.filter((i) => i.Dependants == "Health Dependants")?.length ? finalData.filter((i) => i.Dependants == "Health Dependants") : [] : []
        );
        // setDependentInformation(
        //   finalData.length > 1
        //     ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Health Dependants")?.length ? finalData.filter((i) => i.EmployeeID !== i.SubscriberID && i.Dependants == "Health Dependants") : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        //     : [
        //       {
        //         ...initialDependent,
        //         subscriberId: employeeId,
        //         email: values?.email,
        //         mailingAddress: values?.mailingAddress,
        //         lastName: values?.last_name,
        //       },
        //     ]
        // );
      })
      .catch((error) => {

      }).finally(() => {
        setLoading(false)
      })
  }


  const handleOpen = () => {
    setIsDocumentViewer(true);
  };

  const handleUnClick = () => {
    setValues({ ...values, healthPlan: "", HealthVendor: "", healthDeductionClass: "" })
  }


  return (
    <Fragment>

      {isConfirmationModel &&
        <ConfirmationModel
          open={isConfirmationModel}
          setOpen={setIsConfirmationModel}
          // healthName={isDeSelectedHealth}
          handleSubmit={handleUnClick}
          modelTitle={"Are you sure to unsubscribe Health Insurance"}
        />
      }

      {isDocumentViewer && (
        <DocumentViewer
          open={isDocumentViewer}
          setOpen={setIsDocumentViewer}
          fullWidth
          fieldName={"healthSubscriberId"}
          getBenefitsData={getBenefitsData}
          selfData={{ lastName: selfData?.LastName, middleName: selfData?.FirstName, SubscriberID: selfData?.EmployeeID }}
          handleDependentUpdate={handleDependentUpdate}
        />
      )}
      {loding && loadingPanel()}
      <Container fluid={true}>
        <Row className="bg-primary rounded m-0 p-0 py-3 mb-3 ">
          <Typography variant="h5">
            <Icon style={{ fontSize: "25px", margin: "10px" }} name="graph" />
            Change Status
          </Typography>
        </Row>
        {
          !loding && (
            !values.healthPlan ?
              <Alert severity="error" style={{ marginTop: "10px" }}>No Health Plan Is Selected</Alert> : null
          )
        }
        {/* {!show && !loding ? <Card style={{ marginTop: "10px" }}>
          <div style={{ padding: "40px", textAlign: 'center', fontSize: "26px" }}>
            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <SadImg></SadImg>
            </div>
            Employee details not found!
          </div>
        </Card> : null} */}
        {values?.Employeetype ? (
          <>
            <Card style={{ marginTop: "10px" }}>
              <Accordion
                className={classes.root}
                expanded={expanded.healthandDeduction}
                onChange={handleChangeExpanded("healthandDeduction")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="sub-header w-100 p-1 bg-primary text-white"
                  style={{ width: "100%" }}
                >
                  <FontAwesomeIcon
                    icon={faRectangleList}
                    className="sub-header"
                    style={{
                      // color: "#1569C7",
                      marginRight: "10px",
                      marginTop: "3px",
                    }}
                  />
                  <div className="d-flex justify-content-between" style={{ width: "100%" }}  >
                    <div style={{ fontSize: "0.9375rem", fontWeight: "bold" }}>
                      Health and Deduction Plan
                    </div>
                    <div style={{ marginRight: "20px" }}>
                      {/* <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {getDateDifference()?.diffDays} Days</span>
                      Until Open Enrollment Ends on
                      <span style={{ fontSize: "1rem", fontWeight: "bold", margin: "0px 5px" }}> {moment(getDateDifference()?.defaultDate).format("MMM DD,YYYY")}</span> */}

                    </div>
                  </div>
                  {/* <Typography
                    className={classes.heading}
                    style={{ height: "auto" }}
                  >
                    Health and Deduction Plan
                  </Typography> */}

                </AccordionSummary>
                <AccordionDetails className="p-0 page-body-wrapper">
                  <ActiveHealthAndDeductionPlan
                    renderTextInput={renderTextInput}
                    renderCheckbox={renderCheckbox}
                    renderDropDown={renderDropDown}
                    renderDateInput={renderDateInput}
                    setValues={setValues}
                    values={values}
                    selfData={selfData}
                    handleUpdatePlan={handleUpdatePlan}
                    renderGroupCheckbox={renderGroupCheckbox}
                    isActiveUpdatePlan={
                      dependentInformation.length ? false : true
                    }
                  />
                </AccordionDetails>
              </Accordion>
            </Card>

            <Card style={{ marginTop: "10px" }}>
              <Accordion
                className={classes.root}
                expanded={expanded.dependent}
                onChange={handleChangeExpanded("dependent")}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel2bh-content"
                  id="panel2bh-header"
                  className="sub-header w-100 p-1 bg-primary text-white"
                  style={{ width: "100%" }}
                >
                  <FontAwesomeIcon
                    icon={faRectangleList}
                    className="sub-header"
                    style={{
                      // color: "#1569C7",
                      marginRight: "10px",
                      marginTop: "3px",
                    }}
                  />
                  <Typography
                    className={classes.heading}
                    style={{ height: "auto" }}
                  >
                    Health Dependent Information
                  </Typography>
                </AccordionSummary>
                <AccordionDetails className="p-0 page-body-wrapper">
                  <DependentSelection
                    dependentInformation={dependentInformation}
                    setDependentInformation={setDependentInformation}
                    initialDependent={{
                      ...initialDependent,
                      subscriberId: values?.employee_no,
                      email: values?.email,
                      mailingAddress: values?.mailingAddress,
                      lastName: values?.last_name
                    }}
                    handleDependentUpdate={handleDependentUpdate}
                    handleDependentDelete={handleDependentDelete}
                    setClassValues={setClassValues}
                    values={values?.healthDeductionClass}
                    allvalues={values}
                    handleOpen={handleOpen}
                    employeeId={employeeId}

                  />
                </AccordionDetails>
              </Accordion>
            </Card>

          </>
        ) : null}
      </Container>
    </Fragment>
  );
};

export default HealthOpenEnrollmentMain;
